import type { ReactNode } from 'react'

import { Tab, TabsWrapper } from './styles'

export interface TabItem<T extends string> {
  /** 고유 식별자 (시도 코드 등) */
  value: T
  /** 화면 표시 텍스트 */
  label: string
  /** 라벨 우측 추가 요소 (뱃지·아이콘 등) */
  trailing?: ReactNode
}

interface TabsProps<T extends string> {
  items: TabItem<T>[]
  value: T
  onChange: (value: T) => void
}

/**
 * 단일 선택 탭 그룹.
 *
 * `role='tab'`을 쓰지 않는 이유:
 *   ARIA Tab pattern은 tabpanel과 함께 동작해야 의미가 있음 (focus 관리, 방향키 nav 등 추가 기대 동작).
 *   여기는 단순 필터/선택이라 `<button aria-pressed>` 가 의도에 더 정확하고 단순함.
 */
export default function Tabs<T extends string>({ items, value, onChange }: TabsProps<T>) {
  return (
    <TabsWrapper>
      {items.map((item) => (
        <Tab
          key={item.value}
          type='button'
          aria-pressed={value === item.value}
          data-trailing={item.trailing ? '' : undefined}
          onClick={() => onChange(item.value)}>
          {item.label}
          {item.trailing}
        </Tab>
      ))}
    </TabsWrapper>
  )
}
